import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ILLNESS_OPTIONS } from './constants';

export const ScreenIllness: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Illness',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const illness = form.watch('illness');

  const handleChange = (option: OnbOptionType<LayoutDataType['illness']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        illness: option.id,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background="dark-solid">
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>What would you like to do in the forest?</OwnAiTitle>

        <UiTypography
          variant="body-medium"
          align="center"
          color="neutral-white"
          style={{ marginTop: -24, marginBottom: 24 }}
        >
          Let the forest guide your choice...
        </UiTypography>

        <OnboardingOptionsList>
          {ILLNESS_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={illness === option.id}
              control={form.control}
              option={{ ...option, title: `${option.emoji} ${option.title}` }}
              name="illness"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`illness-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
